module.exports = __webpack_public_path__ + "static/media/ww-cs.c5ed3e2c.png";